import React from 'react';
import PropTypes from 'prop-types';
import 'AppSrc/core/style/components/form/form-base-components/sub-components/field-title.css';

const FieldTitle = React.memo(({
  fieldTitle,
  optional,
}) => (
  <>
    <p className="field-title">
      {`${fieldTitle}${optional ? ' (optional)' : ''}`}
      {/* Below piece of code is to provide a link of Technology Resiliency to the user under the Question */}
      {/* eslint-disable */}
      {fieldTitle === 'Does this change impact our Technology Recovery Plans?' && (
        <a className="field-link" target='_blank' href='https://vodafone.sharepoint.com/sites/globalpolicyportal/Pages/GCP.aspx?OR=Teams-HL&CT=1665574913045&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiIyNy8yMjA5MDQwMDcxMiIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D#/policy/Global/591'>Pages - GCP (sharepoint.com)</a>
      )}
    </p>
  </>
));

FieldTitle.propTypes = {
  fieldTitle: PropTypes.string,
  optional: PropTypes.bool,
};

export { FieldTitle };
